import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import './Results.css';
import {
  cpfFormat,
  formatName,
  logDebug,
  translateGender,
} from 'utils/AuxiliarFunctions';
import { fixTimezoneOffset } from 'utils/dateFunctions';
import i18n from 'i18n';
import consentRequests from 'services/consentRequests';
import { oids } from 'configs';
import { useNewConsentModalContext } from 'pages/SharePage/Context/NewConsentModalContext';
import { LoadingHU } from 'components/LoadingHU';
import { toast } from 'react-toastify';
import { ToastMessage } from 'components';
import { PaginationComponent } from '../Pagination';
import { EmergencyAccess, OrganizationAccess } from '../Modals';

export function ResultsTable({ results }) {
  const { organizationList } = useNewConsentModalContext();

  const [openModalOrganization, setOpenModalOrganization] = useState(false);
  const isOpenModalOrganization = (childdata) => {
    setOpenModalOrganization(childdata);
  };
  const [openModalEmergency, setOpenModalEmergency] = useState(false);
  const [itensPerPage, setItensPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const pages = Math.ceil(results.length / itensPerPage);
  const startIndex = currentPage * itensPerPage;
  const endIndex = startIndex + itensPerPage;
  const currentItens = results.slice(startIndex, endIndex);
  const [patientToAccess, setPatientToAccess] = useState('');
  const [organizationToAccess, setOrganizationToAccess] = useState('');

  const [loadingPatientCnes, setLoadingPatientCnes] = useState(false);

  async function getPatientCNES(identifier) {
    setLoadingPatientCnes(true);
    try {
      let organizationNames = [];
      const cnes = await consentRequests.getPatientCNES(identifier);
      if (cnes !== 'network_error') {
        organizationNames = cnes?.map((cnesElement) => {
          let nameFound = '';
          try {
            nameFound = organizationList?.find((orgElement) =>
              orgElement.resource.id.includes(cnesElement),
            ).resource.alias[0];
          } catch (err) {
            logDebug(err);
          }

          return nameFound;
        });
        toast.success(<ToastMessage type="success" />);
      }
      if (cnes) setPatientToAccess({ patientIdentifier: identifier, cnes });
      if (organizationNames) setOrganizationToAccess(organizationNames);
    } catch (err) {
      toast.error(<ToastMessage type="error">{err}</ToastMessage>);
    }
    setLoadingPatientCnes(false);
    setOpenModalOrganization(true);
  }
  return (
    <>
      {results && (
        <div className="table">
          <div className="table-header">
            <p className="header-col first">CPF</p>
            <p className="header-col">Nome</p>
            <p className="header-col birthDate">Data de Nascimento</p>
            <p className="header-col gender">Sexo</p>
          </div>

          {currentItens.map((patient, index) => (
            <>
              <div
                key={`advancedSearchResults-${index}`}
                className="table-body"
                onClick={() => {
                  const identifier = patient.resource.identifier.find(
                    (element) =>
                      element.system.includes(oids.cpf) ||
                      element.system.includes(oids.cns),
                  )?.value;
                  if (identifier) getPatientCNES(identifier);
                }}
                role="button"
                tabIndex="0"
              >
                <p className="tbody-row first">
                  {cpfFormat(
                    patient.resource.identifier.find((element) =>
                      element.system.includes(oids.cpf),
                    ).value || 'Não Encontrado',
                  )}
                </p>
                <p className="tbody-row">
                  {formatName(patient.resource.name[0].text)}
                </p>
                <p className="tbody-row birthDate">
                  {fixTimezoneOffset(
                    new Date(patient.resource.birthDate),
                  ).toLocaleDateString(i18n.language)}
                </p>
                <p className="tbody-row gender">
                  {translateGender(patient.resource.gender)}
                </p>
              </div>
              <hr className="end-row" />
            </>
          ))}

          <PaginationComponent
            itens={itensPerPage}
            totalItens={results.length}
            setItensPerPage={setItensPerPage}
            setCurrentPage={setCurrentPage}
            pages={pages}
            currentPage={currentPage}
          />
        </div>
      )}
      <LoadingHU state={loadingPatientCnes} />
      {openModalOrganization ? (
        <OrganizationAccess
          isOpen={isOpenModalOrganization}
          openModalEmergency={setOpenModalEmergency}
          patient={patientToAccess}
          organization={
            patientToAccess.cnes !== 'network_error'
              ? patientToAccess.cnes.map((cnesElement, index) => ({
                  name: organizationToAccess[index],
                  cnes: cnesElement,
                }))
              : []
          }
        />
      ) : (
        <></>
      )}
      {openModalEmergency ? (
        <EmergencyAccess
          isOpen={openModalEmergency}
          setIsOpen={setOpenModalEmergency}
          patient={patientToAccess}
        />
      ) : (
        <></>
      )}
    </>
  );
}
ResultsTable.propTypes = {
  results: PropTypes.element.isRequired,
};
